const CONFIG = {
    'backendUrl': 'https://client-simron-fueling-api.rmtcfm.com'
};

module.exports = CONFIG;
